import httpClient from "./httpClient";
import { HospitalFilter } from "../types/filters";
import { Organisation } from "../types/organisation";
import { Listing, ListingShort } from "../types/listings";
import { Hospital } from "../types/hospitals";
import { User } from "../types/users";
import { Group } from "../types/groups";
import { HealthService } from "../types/healthservice";

const getUserHospitalGroups = async (
	id: number
): Promise<HospitalFilter[] | undefined> => {
	const response = await httpClient.get(`/users/${id}/hospitalandgroups`);
	return response.data as HospitalFilter[];
};

const fetchHealthServices = async (): Promise<HealthService[] | undefined> => {
	const response = await httpClient.get("/healthservices");
	return response.data as HealthService[];
};

const fetchHospitals = async (): Promise<Hospital[] | undefined> => {
	const response = await httpClient.get("/hospitals");
	return response.data as Hospital[];
};
const fetchHospitalUsers = async (id: number): Promise<User[] | undefined> => {
	const response = await httpClient.get(`/hospitals/${id}/users`);
	return response.data as User[];
};
const fetchHospitalGroups = async (
	id: number
): Promise<Group[] | undefined> => {
	const response = await httpClient.get(`/hospitals/${id}/groups`);
	return response.data as Group[];
};
export const fetchListings = async (): Promise<ListingShort[] | undefined> => {
	const response = await httpClient.get("/listings/short");
	return response.data as ListingShort[];
};
const fetchOrganisations = async (): Promise<Organisation[] | undefined> => {
	const response = await httpClient.get("/organisations");
	return response.data as Organisation[];
};
const fetchOrgListings = async (id: number): Promise<Listing[] | undefined> => {
	const response = await httpClient.get(`/organisations/${id}/listings`);
	return response.data as Listing[];
};
const fetchOrgUsers = async (id: number): Promise<User[] | undefined> => {
	const response = await httpClient.get(`/organisations/${id}/users`);
	return response.data as User[];
};

export {
	fetchHealthServices,
	getUserHospitalGroups,
	fetchHospitals,
	fetchHospitalUsers,
	fetchHospitalGroups,
	fetchOrganisations,
	fetchOrgListings,
	fetchOrgUsers
};
